
// // import React from 'react'
// // import api from '../api'
// // import { useNavigate } from 'react-router-dom'

// // export default function Login({setUser}){
// //   const [username,setUsername]=React.useState('admin');
// //   const [password,setPassword]=React.useState('password');
// //   const nav = useNavigate();

// //   async function submit(e){
// //     e.preventDefault();
// //     try{
// //       const res = await api.post('/login',{username,password});
// //       const {token,user} = res.data;
// //       localStorage.setItem('token', token);
// //       localStorage.setItem('user', JSON.stringify(user));
// //       setUser(user);
// //       nav('/');
// //     }catch(e){
// //       alert('Login failed');
// //     }
// //   }

// //   return (
// //     <div className="max-w-md mx-auto mt-20 bg-white p-6 rounded shadow">
// //       <h2 className="text-2xl mb-4">Login</h2>
// //       <form onSubmit={submit} className="flex flex-col gap-3">
// //         <input className="border p-2" value={username} onChange={e=>setUsername(e.target.value)} />
// //         <input className="border p-2" type="password" value={password} onChange={e=>setPassword(e.target.value)} />
// //         <button className="bg-blue-600 text-white px-3 py-2 rounded">Login</button>
// //       </form>
// //     </div>
// //   )
// // }


// import React, { useState } from 'react';
// import api from '../api';
// import { useNavigate } from 'react-router-dom';

// export default function Login({ setUser }) {
//   const [credentials, setCredentials] = useState({ username: 'admin', password: 'password' });
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState('');
//   const [showPassword, setShowPassword] = useState(false);
//   const navigate = useNavigate();

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setCredentials(prev => ({ ...prev, [name]: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError('');

//     try {
//       const res = await api.post('/login', credentials);
//       const { token, user } = res.data;
//       localStorage.setItem('token', token);
//       localStorage.setItem('user', JSON.stringify(user));
//       setUser(user);
//       navigate('/');
//     } catch (err) {
//       console.error(err);
//       setError(err.response?.data?.message || 'Login failed');
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="max-w-md mx-auto mt-20 bg-white p-6 rounded shadow">
//       <h2 className="text-2xl mb-4 text-center font-semibold">Login</h2>

//       {error && (
//         <div className="bg-red-100 text-red-700 px-3 py-2 rounded mb-3 text-sm">
//           {error}
//         </div>
//       )}

//       <form onSubmit={handleSubmit} className="flex flex-col gap-3">
//         <input
//           name="username"
//           placeholder="Username"
//           className="border p-2 rounded"
//           value={credentials.username}
//           onChange={handleChange}
//           required
//         />

//         <div className="relative">
//           <input
//             name="password"
//             type={showPassword ? 'text' : 'password'}
//             placeholder="Password"
//             className="border p-2 rounded w-full"
//             value={credentials.password}
//             onChange={handleChange}
//             required
//           />
//           <button
//             type="button"
//             onClick={() => setShowPassword(prev => !prev)}
//             className="absolute right-2 top-2 text-gray-500 text-sm"
//           >
//             {showPassword ? 'Hide' : 'Show'}
//           </button>
//         </div>

//         <button
//           type="submit"
//           disabled={loading}
//           className={`bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
//         >
//           {loading ? 'Logging in...' : 'Login'}
//         </button>
//       </form>
//     </div>
//   );
// }


import React, { useState } from 'react';
import api from '../api';
import { useNavigate } from 'react-router-dom';

export default function Login({ setUser }) {
  const [credentials, setCredentials] = useState({ username: 'admin', password: 'password' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const res = await api.post('/login', credentials);
      const { token, user } = res.data;

      // ✅ Store token & user based on "Remember Me"
      if (rememberMe) {
        localStorage.setItem('token', token);
        localStorage.setItem('user', JSON.stringify(user));
      } else {
        sessionStorage.setItem('token', token);
        sessionStorage.setItem('user', JSON.stringify(user));
      }

      setUser(user);
      navigate('/');
    } catch (err) {
      console.error(err);
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-20 bg-white p-6 rounded shadow">
      <h2 className="text-2xl mb-4 text-center font-semibold">Login</h2>

      {error && (
        <div className="bg-red-100 text-red-700 px-3 py-2 rounded mb-3 text-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col gap-3">
        <input
          name="username"
          placeholder="Username"
          className="border p-2 rounded"
          value={credentials.username}
          onChange={handleChange}
          required
        />

        <div className="relative">
          <input
            name="password"
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            className="border p-2 rounded w-full"
            value={credentials.password}
            onChange={handleChange}
            required
          />
          <button
            type="button"
            onClick={() => setShowPassword(prev => !prev)}
            className="absolute right-2 top-2 text-gray-500 text-sm"
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>

        {/* ✅ Remember Me Checkbox */}
        <div className="flex items-center gap-2">
          <input
            type="checkbox"
            id="rememberMe"
            checked={rememberMe}
            onChange={(e) => setRememberMe(e.target.checked)}
            className="w-4 h-4"
          />
          <label htmlFor="rememberMe" className="text-sm select-none">
            Remember Me
          </label>
        </div>

        <button
          type="submit"
          disabled={loading}
          className={`bg-blue-600 text-white px-3 py-2 rounded hover:bg-blue-700 transition-colors ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
        >
          {loading ? 'Logging in...' : 'Login'}
        </button>
      </form>
    </div>
  );
}
